import { LwApiPM } from "@techniaorg/liteweb-api";
import { LwScreenshotOptions } from "@techniaorg/liteweb-api/dist/types/lw-public-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_screenshot(options?: LwScreenshotOptions) {
  var prefix = (document.getElementById("prefix") as HTMLInputElement).value;
  LwAPI?.applyConfig({ screenshotPrefix: prefix }).then(() => {
    LwAPI?.screenshot(options).then((result) => {
      (document.getElementById("output") as HTMLTextAreaElement).value = result;
    });
  });
}

function ex_screenshot_window() {
  LwAPI?.screenshot().then(function (result) {
    var img = new Image();
    img.src = result;
    var wnd = window.open("");
    wnd?.document.write(img.outerHTML);
  });
}

// Bind functions to buttons
document.getElementById("screen1")?.addEventListener("click", async () => {
  await apiReady;
  ex_screenshot();
});
document.getElementById("screen2")?.addEventListener("click", async () => {
  await apiReady;
  ex_screenshot({ promptSaveDialog: true });
});
document.getElementById("screen3")?.addEventListener("click", async () => {
  await apiReady;
  ex_screenshot({ promptSaveDialog: true, type: "image/jpeg" });
});
document.getElementById("screen4")?.addEventListener("click", async () => {
  await apiReady;
  ex_screenshot({
    promptSaveDialog: true,
    type: "image/jpeg",
    encoderOptions: 0.5,
  });
});
document.getElementById("screen5")?.addEventListener("click", async () => {
  await apiReady;
  ex_screenshot_window();
});
